import { render } from "./심장내과.vue?vue&type=template&id=44292f68"
import script from "./심장내과.vue?vue&type=script&lang=js"
export * from "./심장내과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__